// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//TEMP, remove once the DEBUG navigate is removed
import { Router } from '@angular/router';
//TEMP

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';
import { exportCsvDTO } from '../../shared/library/export';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";



// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CppeMainComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.capp-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.capp-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.capp-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.capp-legend-item-div{margin:0 16px 0 2px}.capp-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.capp-control-lbl{margin-right:4px}.capp-filter-radio{padding-left:10px;display:flex;align-items:center}.capp-main-control-break{flex-basis:100%;height:0}.capp-cssClasses_Grid{border-top:solid 1px #bbb}.capp-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.capp-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.capp-cssClasses_EditableCell_complete{border:solid 1px green !important}'],
    template : '<!--Content Div-->\n<div class="capp-main-content-div" data-test-id="content_capp_main">\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Title -->\n    <!-- ---------------------------------------------------- -->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n    <div class="cpd-subtitle-div">{{_subTitle}}</div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER (hidden during loading operations)-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Control Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-control-div">\n\n            <!--FISCAL YEAR-->\n            <div class="cpd-control-unit">\n\n                <label for="selFY" class="capp-control-lbl">Fiscal Year</label>\n                <select id="selFY" [disabled]="_disableControls" [(ngModel)]="_selectedFY" (change)="fiscalYearChanged($event)">\n                    <option *ngFor="let fy of _fiscalYears;" [ngValue]="fy">{{fy}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--PRACTICE TYPE-->\n            <div class="cpd-control-unit">\n\n                <label for="selPTC" class="capp-control-lbl">Asset Type</label>\n                <select id="selPTC" [disabled]="_disableControls" [(ngModel)]="_selectedPracticeType" (change)="practiceTypeChanged($event)">\n                    <option *ngFor="let practiceType of _practiceTypes;" [ngValue]="practiceType">{{practiceType.practice_type_code_display}}</option>\n                </select>\n\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--Date Range-->\n            <div class="cpd-control-unit">\n                <label *ngIf="_fiscalStart" class="capp-control-lbl">Start Date: {{_fiscalStart | date}}</label>\n                <label *ngIf="!_fiscalStart" class="capp-control-lbl">Start Date: --</label>\n                <div style="width:20px;"></div>\n            </div>\n            <div class="cpd-control-unit">\n                <label *ngIf="_fiscalEnd" class="capp-control-lbl">End Date: {{_fiscalEnd | date}}</label>\n                <label *ngIf="!_fiscalEnd" class="capp-control-lbl">End Date: --</label>\n                <div style="width:20px;"></div>\n            </div>\n\n            <!--GO BUTTON -->\n            <div class="cpd-control-unit">\n                <button type="button" class="btn btn-primary" [disabled]="!_goButtonOn || _disableControls" (click)="goButtonClicked()">GO</button>\n            </div>\n\n        </div>\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Grid Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-grid-div">\n            <cas-grid #mainGrid\n                      [settings]="_mainGridSettings"\n                      summary="{{_title}}"\n                      (onRowSelectionChanged)="gridRowSelected()"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n        where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n        are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="capp_main_page_popups"></div>\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Export Popup -->\n        <!-- ---------------------------------------------------- -->\n        <modal #popExportCAAP\n               containerId="capp_main_page_popups"\n               title="Export All CAPP Data"\n               label="popExportCAAP"\n               customClass="capp-ui-popup-export">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_capp_main_export_all"></section>\n\n            <!--BODY-->\n            <section *ngIf="_exportingCaap" class="cpd-ui-content-loading">\n                <img src="public/cpd-images/loading.gif" />\n                <div style="margin-left:10px;">exporting capp points...</div>\n            </section>\n\n            <section *ngIf="!_exportingCaap">\n\n                <!--FISCAL YEAR-->\n                <div class="cpd-control-unit">\n                    <label class="capp-control-lbl" style="width:90px;">Fiscal Year:</label>{{_selectedFY}}\n                </div>\n\n                <!--PRACTICE TYPE-->\n                <div class="cpd-control-unit">\n                    <label class="capp-control-lbl" style="width:90px;">Asset Type:</label>{{_selectedPracticeType.practice_type_code_display}}\n                </div>\n\n                <!--LAND USE DDL-->\n                <div class="cpd-control-unit">\n                    <label for="selLandUse" class="capp-control-lbl" style="width:90px;">Land Use:</label>\n                    <select id="selLandUse" [disabled]="_disableControls" [(ngModel)]="_selectedLandUse">\n                        <option *ngFor="let landUse of _landUses;" [ngValue]="landUse">{{landUse.land_use_display}}</option>\n                    </select>\n                </div>\n\n            </section>\n\n            <!--FOOTER-->\n            <footer>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" (click)="exportAllCAAPPoints()">Export</button>\n            </footer>\n\n\n        </modal>\n\n\n    </ng-container>\n\n</div>\n',
    providers:[],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class CappMainComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('mainGrid') mainGrid;
    @ViewChild('popExportCAAP') popExportCAAP;
    
	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'cappMain.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'capp'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _sessionStorageObject = null;
    _title = "CAPP - Assets List";
    _subTitle = "Select an asset to edit its associated narratives.";

    //Data
    _fiscalYears = [];
    _fiscalStart = '';
    _fiscalEnd = '';
    _landUses = [];                     //Used for popup
    _practiceTypes = [];
    _selectedFY;
    _selectedLandUse = null;
    _selectedPracticeType = null;
    _selectedRow = null;

    //UI Indicators
    _goButtonOn = false;
    _loadingPoints = false;
    _exportingCaap = false;

    //Main Grid
    _mainGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox:false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_name",
        rowIdentityPrefixForJAWS: "Practice Name",
        cssClasses_Grid: "capp-cssClasses_Grid",
        cssClasses_Cell: "capp-cssClasses_Cell",
        columns: [
            { fieldName: 'practice_code', display: 'Asset Code', width: '10%', minWidth: 30 },
            { fieldName: 'practice_name', display: 'Asset Name', width: '70%', minWidth: 100 },
            { fieldName: 'narrative_count', display: 'Total Narratives', width: '10%', minWidth: 50, dataType: 'int' },
            {
                fieldName: 'action_required', display: 'Action Required', width: '10%', minWidth: 50, dataType: 'int', procDataFn: (fieldValue, row) => {
                    return this._selectedFY != this.helpers.getFY() ? 'N' : fieldValue;
                }
            }
        ]
    };


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //DEBUG, remove router once the DEBUG navigate is removed
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        //formDataService: FormDataService2,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

		// Growl Prep
		//--------------------
		this.growlBox = new BCGrowls("growlBox");
		this.growlBox.init({ 
			appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
		}); 

        //Actions
        //Init the local storage for this page
        this._sessionStorageObject = this._loadSessionStorageObject();

        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedFiscalYear: this.helpers.getFY()
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Set title 
        //--------------------
        if (this._authToken.IsState()) {
            this._title = this._authToken.user.stateName + " - CAPP - Assets List";
            this._subTitle = "Select an asset to view its associated narratives.";
        }
        else {
            this._title = "CAPP - Assets List";
            this._subTitle = "Select an asset to edit its associated narratives.";
        }

        // Set grid columns for state users to remove Action Required column
        if (this._authToken.IsState()) {
            this._mainGridSettings.columns = [
                { fieldName: 'practice_code', display: 'Asset Code', width: '10%', minWidth: 30 },
                { fieldName: 'practice_name', display: 'Asset Name', width: '70%', minWidth: 100 },
                { fieldName: 'narrative_count', display: 'Total Narratives', width: '10%', minWidth: 50, dataType: 'int' },
            ];
        }

        // Validation
        //--------------
        this.casValidate = new CASValidate();

        // Debugging 
        //--------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Navigate to Edit");

        disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
            this.debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);

        this._disableControls = false;
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        this.casNavBoxService.ActionsLoading = true;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        //Async ops
        let ops = 3;

        //FISCAL YEARS
        this.initFiscalYears(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //PRACTICE TYPES
        this.initPracticeTypes(() => {

            //LAND USES and CAPP GRID 
            this.initLandUses(() => {

                this.initCappGrid(() => {
                    if (--ops == 0) { this.ngOnInit_Complete(); }
                });
            });
        });

        //FORMS
        // Both National and State Data Stewards can now access this screen
        let actions = [];
        switch (this._authToken.user.role) {

            // NHQNationalPracticeDataSteward
            //-------------------------------------
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_edit_practice_points_v2", "Edit / View Asset Points"));
                actions.push(new FormAction("act_export_caap", "Export All CAPP Data"));
                actions.push(new FormAction("", "Annual Rollover", false));
                break;

            // StateDataSteward
            //-------------------------------------
            case Enums.Roles.StateDataSteward.id:
                actions.push(new FormAction("act_edit_practice_points_v2", "View Asset Points"));
                actions.push(new FormAction("act_export_caap", "Export All CAPP Data"));
                break;

            // StateDataSteward
            //-------------------------------------
            case Enums.Roles.NationalDisciplineDataSteward.id:
                actions.push(new FormAction("act_edit_practice_points_v2", "View Asset Points"));
                actions.push(new FormAction("act_export_caap", "Export All CAPP Data"));
                break;

        }
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = true;

        if (--ops == 0) { this.ngOnInit_Complete(); }
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        //Init the validation class
        this.casValidate.initialize(true);
        this._goButtonOn = true;
        this._pageLoading = false;
        this.casNavBoxService.ActionsLoading = false;
    };


    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        switch (action.field_name.toLowerCase()) {

            case "act_edit_practice_points_v2":
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "Please select a row to edit");
                    return;
                }

                let routeV2 = "/cpdes/capp/dashboard/{0}/{1}".format(this._selectedFY, this._selectedRow.practice_state_id);
                this.router.navigate([routeV2]);
                break;


            case "act_export_caap":
                this.openExportAllCAAPPoints();
                break;
        }

    };


    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // fiscalYearChanged
    //==================================
    fiscalYearChanged(e) {

        //Clear the grid as the data here is not invalid and could be confusing when someone opens the edit 
        //popup which will have the new fy data displayed.
        this.mainGrid.ClearRows();
        this._selectedRow = null;

        //Clear any search box filters
        this.mainGrid.ClearFilter("search", false);
        this.mainGrid.ClearSearchBox();

        //Get fiscal year date range
        this.getFiscalYearDateRange((dateRange) => {
            this._fiscalStart = dateRange.start;
            this._fiscalEnd = dateRange.end;
        });

        this.updateSessionStorage();
    };

    //==================================
    // goButtonClicked
    //==================================
    //  callback<fn>:       //(opt,null)
    goButtonClicked(fnOnComplete) {

        this._goButtonOn = false;
        this.mainGrid.MarkAsLoading(true);

        //Clear any search box filters
        this.mainGrid.ClearFilter("search", false);
        this.mainGrid.ClearSearchBox();

        let fy = this._selectedFY || null;

        let stateCountyCode = "00000";
        if (this._authToken.IsState()) {
            stateCountyCode = this._authToken.user.stateCode + "000";
        }

        //Load the filtered CAPP practices
        this.loadCAPPPractices(fy, this._selectedPracticeType.practice_type_code, stateCountyCode, (dto) => {

            //Update the grid to show the practices (grid should be loaded by the time GO can be clicked)
            this.mainGrid.SetRows(dto);

            //Clean up UI load indicators
            this.mainGrid.MarkAsLoading(false);
            this._goButtonOn = true;

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        this.resetSelectedFiscalYear();
        this.updateSessionStorage();
        
        // Refresh grid
        this.goButtonClicked();
    }

    //==================================
    // gridRowSelected 
    //==================================
    gridRowSelected(row) {
        //This is called when a row is selected AND unselected, resulting in a "null" selected row when unselected
        this._selectedRow = this.mainGrid.GetFirstSelectedRow(); //There will only be one for this single-select grid
        //console.log("  [{0}:gridRowSelected()] row:".format(this._componentName), this._selectedRow);
    }

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText){
        
        //console.log("onGridSearch", event);

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.mainGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.mainGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //==================================
    // practiceTypeChanged
    //==================================
    practiceTypeChanged(e) {
        //Nothing to do at this point as the go button handles executing the change
    }


    // BUSINESS LOGIC & NON-UI EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // exportAllCAAPPoints
    //=======================================
    exportAllCAAPPoints() {

        console.log("  [{0}:exportAllCAAPPoints()]".format(this._componentName));

        if (this._mainGridSettings.rows.length == 0){
            this.growlBox.addGrowl("info", "No rows to export");
            this.popExportCAAP.Close();
            return;
        }

        this._exportingCaap = true;
        this.growlBox.addGrowl("info", "Exporting capp...");

        let stateCountyCode = "00000";
        if (this._authToken.IsState()) {
            stateCountyCode = this._authToken.user.stateCode + "000";
        }

        this.webServices.Get({
            apiPath: "/capp/exportCAAPPoints",
            args: {
                selectedFY: this._selectedFY,
                practiceType: this._selectedPracticeType.practice_type_code,
                stateCountyCode: stateCountyCode || "00000",
                landUseId: this._selectedLandUse.land_use_id == -1 ? null : this._selectedLandUse.land_use_id
            }
        })
        .then(res => {

            if (!res.data.DTO || res.data.DTO == ""){
                this.growlBox.addGrowl("info", "No point records found for the indicated search.");
                this._exportingCaap = false;
                this.popExportCAAP.Close();
                return;
            }

            this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

            console.log("[{0}:exportAllCAAPPoints():/capp/exportCAAPPoints] - res:".format(this._componentName), res);
            this.popExportCAAP.Close();
            this._exportingCaap = false;

            //Popup in new window
            exportCsvDTO(res.data.DTO, 'CAPP', this._selectedLandUse.land_use_display);
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            this._exportingCaap = false;
        });

        //Grab the data from the server
        //console.log("   _selectedFY", this._selectedFY);
        //console.log("   _selectedPracticeType", this._selectedPracticeType);
        //console.log("   _selectedLandUse", this._selectedLandUse);
        //capp/exportCAAPPoints
    }

    //=======================================
    // flattenRCC_DTO
    //=======================================
    // New DTO format for RCC data is bundelled into objects.  The grid cannot read nested properties.  I tried to add that functionality,
    // but the grid relies too heavily on the flat structure.  The show stopper was sections in the markup that adds "working poperties"
    // to an existing field (making it its own object).  So, we'll just flatten the response form the server back to the old format,
    // but with the new land use data.
    flattenRCC_DTO(dto) {

        let arrOut = [];

        for (let i = 0; i < dto.length; i++) {

            let curRow = dto[i];

            let flatRow = {
                resource_concern_component_id: curRow.component.resource_concern_component_id,
                resource_concern_component_name: curRow.component.resource_concern_component_name,
                resource_concern_component_display: curRow.component.resource_concern_component_display,
                resource_concern_component_description: curRow.component.resource_concern_component_description,
                resource_concern_component_objective: curRow.component.resource_concern_component_objective,
                resource_concern_component_start_date: curRow.component.start_date,
                resource_concern_component_end_date: curRow.component.end_date,
                resource_concern_component_publish: curRow.component.publish,

                resource_concern_id: curRow.concern.resource_concern_id,
                resource_concern_name: curRow.concern.resource_concern_name,
                resource_concern_display: curRow.concern.resource_concern_display,
                resource_concern_description: curRow.concern.resource_concern_description,
                resource_concern_start_date: curRow.concern.start_date,
                resource_concern_end_date: curRow.concern.end_date,
                resource_concern_publish: curRow.concern.publish,
                swapa_category_id: curRow.concern.swapa_category_id,

                resource_concern_category_id: curRow.category.resource_concern_category_id,
                resource_concern_category_name: curRow.category.resource_concern_category_name,
                resource_concern_category_display: curRow.category.resource_concern_category_display,

                selected_land_use_ids: {}
            }


            //Add any associated land uses
            if (curRow.land_uses) {
                for (let j = 0; j < curRow.land_uses.length; j++) {
                    let curLandUse = curRow.land_uses[j].landuse;
                    flatRow.selected_land_use_ids[curLandUse.land_use_id] = curLandUse.land_use_id;
                }
            }

            arrOut.push(flatRow);

        }

        console.log("[{0}:flattenRCC_DTO()]:".format(this._componentName), arrOut);

        return arrOut;

    }

    //=======================================
    // initCappGrid
    //======================================
    initCappGrid(fnOnComplete) {

        if (!this._selectedLandUse) { throw ("Cannot call initCappGrid() until a land use has been selected"); }

        //Initial fy will always be the current fy (initFiscalYears() follows the same convention)
        let fy = this.helpers.getFY();
        let practiceTypeCode = this._selectedPracticeType.practice_type_code;

        let stateCountyCode = "00000";
        if (this._authToken.IsState()) {
            stateCountyCode = this._authToken.user.stateCode + "000";
        }

        this.loadCAPPPractices(fy, practiceTypeCode, stateCountyCode, (dto) => {

            //Update the grid to show the practices (grid should be loaded by the time GO can be clicked)
            if (this.mainGrid) {
                this.mainGrid.SetRows(dto);
            }
            else {
                this._mainGridSettings.rows = dto;
            }

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //=======================================
    // initFiscalYears
    //======================================
    //  Loads and populates the fy list
    initFiscalYears(fnOnComplete) {

        this.webServices.Get({ apiPath: "/practices/getFiscalYearRangeForAllPracticeStates" })
            .then(res => {

                console.log("[{0}:initFiscalYears():getFiscalYearRangeForAllPracticeStates()] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Build FY list
                var curFY = this.helpers.getFY();
                this._fiscalYears = [];
                for (let i = dto.minFiscalYear; i <= curFY; i++) {
                    this._fiscalYears.push(i);
                }

                //Select the current FY                
                this._selectedFY = this._sessionStorageObject.selectedFiscalYear;

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }

                //Get fiscal year date range
                this.getFiscalYearDateRange((dateRange) => {
                    this._fiscalStart = dateRange.start;
                    this._fiscalEnd = dateRange.end;
                });

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            });
    };

    //=======================================
    // initLandUses
    //======================================
    initLandUses(fnOnComplete) {

        //Init to the current FY
        let fy = this.helpers.getFY();

        //Load the filtered land uses
        this.loadLandUses(fy, (dto) => {

            //Grab a filtered land use list
            this._landUses = dto.filter(lu => {  
                switch(lu.land_use_code.toLowerCase()){
                    case "pr":  //protected
                    case "kw":  //undetermined
                    //case "wa":  //water
                    break;

                    default:
                        return lu;
                }
            });

            //Concat (ES6 Destructuring: https://stackoverflow.com/questions/1584370/how-to-merge-two-arrays-in-javascript-and-de-duplicate-items ) & ( https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment )
            this._landUses = [
                {
                    land_use_code: "-1",
                    land_use_description: null,
                    land_use_display: "All",
                    land_use_id: -1,
                    land_use_name: "All",
                }, 
                ...this._landUses
            ];

            //console.log("--------->",this._landUses);

            //A land use must be selected
            this._selectedLandUse = this._landUses[0];

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    }

    //=======================================
    // initPracticeType
    //======================================
    initPracticeTypes(fnOnComplete) {

        //Load the filtered type codes
        this.loadPracticeTypeCodes(this._selectedFY, (dto) => {
            //Refresh practice type code data/ddl
            this._practiceTypes = dto;
            this._selectedPracticeType = this._practiceTypes[0];
            if (fnOnComplete) { fnOnComplete(); }
        });

        //This is much more constrained than I realized, so let's just hard code 
        //the current codes in use as there is no systematic way to discover them.
        //CAS: Added "code" as a temporary fix until this section gets fixed by the "hard-coded types" story
        //this._practiceTypes = [
        //    { practice_type: "bundles", practice_type_display: "Bundles", code:"B" },
        //    { practice_type: "enhancements", practice_type_display: "Enhancements", code:"E" },
        //    { practice_type: "lteasments", practice_type_display: "Long Term Easements", code:"L" },
        //    { practice_type: "practices", practice_type_display: "Practices", code:"P" },
        //    { practice_type: "rcpp", practice_type_display: "RCPP Practices", code:"R" }
        //];

        ////this._selectedPracticeType = "practices";
        //this._selectedPracticeType = this._practiceTypes[3]; //"Practices"

        //if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }

    }

    //=======================================
    // loadCAPPPractices
    //=======================================
    loadCAPPPractices(fy, practiceTypeCode, stateCountyCode, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/capp/getCAPPPractices",
            args: {
                fy: fy || null,
                practiceTypeCode: practiceTypeCode || null,
                stateCountyCode: stateCountyCode || "00000"
            }
        })
        .then(res => {
            console.log("[{0}:loadCAPPPractices():getCAPPPractices()] - res:".format(this._componentName), res);
            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
        })
        .catch(err => {
            console.log(err);
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }


    //CAS: This doesn't appear to be used.
    //=======================================
    // loadConcernsAndComponents
    //=======================================
    // This is just a wrapper around two service calls that are usually called together to make the code cleaner (build tree)
    // Returns: { concerns:[<obj>], components:[<obj>] }
    //loadConcernsAndComponents(fnOnComplete) {

    //    let ops = 2;
    //    let concerns = [];
    //    let components = [];

    //    //Local functions don't seem to hoist here, so put this up top
    //    var fnLoadsComplete = () => {
    //        if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete({ concerns: concerns, components: components }); }
    //    }

    //    //Load the concerns and components
    //    this.loadResourceConcerns((dto) => {
    //        concerns = dto;
    //        if (--ops == 0) { fnLoadsComplete(); }
    //    });

    //    this.loadResourceConcernComponents((dto) => {
    //        components = this.flattenRCC_DTO(dto);
    //        if (--ops == 0) { fnLoadsComplete(); }
    //    });

    //}

    //=======================================
    // loadLandUses
    //=======================================
    loadLandUses(fy, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/landuse/getLandUses",
            args: {
                fy: fy || null
            }
        })
        .then(res => {
            console.log("[{0}:loadLandUses():getLandUses()] - res:".format(this._componentName), res);
            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadPracticeTypeCodes
    //=======================================
    loadPracticeTypeCodes(fy, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: fy || null,
                includeAll: false
            }
        })
        .then(res => {
            console.log("[{0}:loadPracticeTypeCodes():getPracticeTypeCodes()] - res:".format(this._componentName), res);
            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadResourceConcerns
    //=======================================
    loadResourceConcerns(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getResourceConcerns",
            args: {
                fiscalYear: this._selectedFY,
                swapaCategoryId: null,
                resourceConcernCategoryId: null,
                publishedOnly: true
            }
        })
        .then(res => {
            console.log("[{0}:loadResourceConcerns():getResourceConcerns()] - res:".format(this._componentName), res);
            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadResourceConcernComponents
    //=======================================
    loadResourceConcernComponents(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/resource/getResourceConcernComponents2",
            args: {
                fiscalYear: this._selectedFY,
                resourceConcernId: null,
                resourceConcernComponentId: null,
                publishedOnly: true,
                filterLandUseByFY: false
            }
        })
            .then(res => {
                console.log("[{0}:loadResourceConcernComponents():getResourceConcernComponents2] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //=======================================
    // openExportAllCAAPPoints
    //=======================================
    openExportAllCAAPPoints() {

        this._exportingCaap = false;
        this.popExportCAAP.Open(() => {
            //Fires when the box is closed
        });
    }

    //=======================================
    // Check for Capp Version 2
    // Removing this feature flag
    //=======================================
    //isCappVersion2(fnOnComplete, fnOnError) {

    //    this.webServices.Get({
    //        apiPath: "/featureflag/getFeatureFlag/" + Enums.FeatureFlags.CappVersion2,
    //    })
    //        .then(res => {
    //            console.log("[{0}:loadFeatureFlag():getFeatureFlag()] - res:".format(this._componentName), res);
    //            if (!res.data.DTO) { throw("Cannot find feature flag data for: CappVersion2"); }
    //            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
    //        })
    //        .catch(err => {
    //            console.log(err);
    //            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
    //            if (fnOnError) { fnOnError(); }
    //        });
    //}
    
    //=======================================
    // Get Fiscal Year Date Range
    //=======================================
    getFiscalYearDateRange(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/fiscalyear/getFiscalYearDates",
            args: {
                fiscalYear: this._selectedFY
            }
        })
            .then(res => {
                console.log("[{0}:fiscalyear():getFiscalYearDates()] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_savesessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // resetSelectedFiscalYear
    //==================================
    resetSelectedFiscalYear()
    {
        // Reset selected fiscal year.
        this._selectedFY = this.helpers.getFY();
    }

    //==================================
    // updateSessionStorage
    //==================================
    updateSessionStorage()
    {
        // Update session storage
        this._sessionStorageObject.selectedFiscalYear = this._selectedFY;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // debugEntryClicked
    //=======================================
    debugEntryClicked(entry) {

        console.log("[{0}:debugEntryClicked]".format(this._componentName));
        console.log("    ", entry);

        switch (entry) {

            case "Navigate to Edit":
                this.router.navigate(["/cpdes/capp/edit/2019/41771"]);
                break;


        }
    };
    
};
